/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  EquipmentItemTypesFiltersParams,
  FilterOptionsList,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Equipment Item Type Filters
 */
export const equipmentItemTypesFilters = (
    params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/equipment/item-types`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentItemTypesFiltersQueryKey = (params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>,) => {
    return [
    'filters','equipment','item-types', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentItemTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemTypesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItemTypesFilters>>> = ({ signal }) => equipmentItemTypesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>
}

export type EquipmentItemTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItemTypesFilters>>>
export type EquipmentItemTypesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment Item Type Filters
 */

export function useEquipmentItemTypesFilters<TData = Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentItemTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItemTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemTypesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






